// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2rBGc","actionsCol":"EnrolledClinics_actionsCol__2fq7x"};